export default "__VITE_ASSET__DU5sHa9L__"